import { UILabel, UIView } from "uikit";

export class BookingProductCategoryHeader extends UIView
{
    private titleLabel: UILabel;
    awakeFromNib ( ) {      
        this.titleLabel.text = "HEADER" ;
    }
    
    set title ( name: string ) {
      this.titleLabel.text = name ;
    }
}